var _rect, _rect2, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect3, _path15, _rect4, _path16, _rect5, _path17, _rect6, _path18;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 417,
    viewBox: "0 0 252 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.62402,
    width: 249.603,
    height: 416.004,
    rx: 25,
    transform: "rotate(0.22369 1.62402 0)",
    fill: "#707070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1836,
    y: 45.175,
    width: 194.135,
    height: 322.403,
    transform: "rotate(0.22369 29.1836 45.175)",
    fill: "#D8F4D8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 119.5,
    r: 57.5,
    fill: "#43E240"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 120,
    r: 48,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.435 110.476C156.389 106.288 155.389 100.499 151.202 97.545V97.545C147.015 94.5908 141.225 95.5903 138.271 99.7776L121.714 123.245L136.878 133.943L153.435 110.476Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2885 110.476C95.3343 106.288 96.3339 100.499 100.521 97.545V97.545C104.708 94.5908 110.498 95.5903 113.452 99.7776L130.009 123.245L114.845 133.943L98.2885 110.476Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.19 127.435C154.19 143.45 140.302 145.88 125.752 145.88C111.203 145.88 98.1865 143.45 98.1865 127.435C98.1865 111.42 111.203 98.437 125.752 98.437C140.302 98.437 154.19 111.42 154.19 127.435Z",
    fill: "#FEFFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.017 118.431C108.017 114.648 111.083 111.582 114.866 111.582V111.582C118.648 111.582 121.714 114.648 121.714 118.431V120.419C121.714 124.201 118.648 127.268 114.866 127.268V127.268C111.083 127.268 108.017 124.201 108.017 120.419V118.431Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.017 118.431C108.017 114.648 111.083 111.582 114.866 111.582V111.582C118.648 111.582 121.714 114.648 121.714 118.431V120.419C121.714 124.201 118.648 127.268 114.866 127.268V127.268C111.083 127.268 108.017 124.201 108.017 120.419V118.431Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.447 118.431C129.447 114.648 132.513 111.582 136.296 111.582V111.582C140.078 111.582 143.144 114.648 143.144 118.431V120.419C143.144 124.201 140.078 127.268 136.296 127.268V127.268C132.513 127.268 129.447 124.201 129.447 120.419V118.431Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.447 118.431C129.447 114.648 132.513 111.582 136.296 111.582V111.582C140.078 111.582 143.144 114.648 143.144 118.431V120.419C143.144 124.201 140.078 127.268 136.296 127.268V127.268C132.513 127.268 129.447 124.201 129.447 120.419V118.431Z",
    fill: "#C4C4C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.055 119.425C111.055 117.32 112.761 115.614 114.866 115.614V115.614C116.97 115.614 118.677 117.32 118.677 119.425V119.425C118.677 121.529 116.97 123.236 114.866 123.236V123.236C112.761 123.236 111.055 121.529 111.055 119.425V119.425Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.055 119.425C111.055 117.32 112.761 115.614 114.866 115.614V115.614C116.97 115.614 118.677 117.32 118.677 119.425V119.425C118.677 121.529 116.97 123.236 114.866 123.236V123.236C112.761 123.236 111.055 121.529 111.055 119.425V119.425Z",
    fill: "#151414"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.107 129.422C121.107 127.317 122.814 125.611 124.918 125.611H127.404C129.508 125.611 131.215 127.317 131.215 129.422V129.422C131.215 131.526 129.508 133.232 127.404 133.232H124.918C122.814 133.232 121.107 131.526 121.107 129.422V129.422Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.107 129.422C121.107 127.317 122.814 125.611 124.918 125.611H127.404C129.508 125.611 131.215 127.317 131.215 129.422V129.422C131.215 131.526 129.508 133.232 127.404 133.232H124.918C122.814 133.232 121.107 131.526 121.107 129.422V129.422Z",
    fill: "#262626"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.485 119.425C132.485 117.32 134.191 115.614 136.296 115.614V115.614C138.4 115.614 140.107 117.32 140.107 119.425V119.425C140.107 121.529 138.4 123.236 136.296 123.236V123.236C134.191 123.236 132.485 121.529 132.485 119.425V119.425Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.485 119.425C132.485 117.32 134.191 115.614 136.296 115.614V115.614C138.4 115.614 140.107 117.32 140.107 119.425V119.425C140.107 121.529 138.4 123.236 136.296 123.236V123.236C134.191 123.236 132.485 121.529 132.485 119.425V119.425Z",
    fill: "#151414"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29 211C29 199.954 37.9543 191 49 191H202C213.046 191 222 199.954 222 211V368H29V211Z",
    fill: "#F3F5F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 199,
    width: 71,
    height: 58,
    rx: 20,
    fill: "#EDC992"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43 230H114V237C114 248.046 105.046 257 94 257H63C51.9543 257 43 248.046 43 237V230Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 199,
    width: 71,
    height: 58,
    rx: 20,
    fill: "#BCBBF4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M139 230H210V237C210 248.046 201.046 257 190 257H159C147.954 257 139 248.046 139 237V230Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 287,
    width: 71,
    height: 58,
    rx: 20,
    fill: "#DFF4BB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43 318H114V325C114 336.046 105.046 345 94 345H63C51.9543 345 43 336.046 43 325V318Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 287,
    width: 71,
    height: 58,
    rx: 20,
    fill: "#F3BBF4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M139 318H210V325C210 336.046 201.046 345 190 345H159C147.954 345 139 336.046 139 325V318Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature_3.60adbd17.svg";
export { ForwardRef as ReactComponent };